'use client';
import React, { FunctionComponent, useMemo } from 'react';
import { useLocale } from '../../../hooks/useLocale';

type PricingLabelProps = {
    price: number;
    currency: string;
};
export const PricingLabel: FunctionComponent<PricingLabelProps> = ({ price, currency }) => {
    const { locale } = useLocale();

    const formattedPrice = useMemo(() => {
        try {
            return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency,
                minimumFractionDigits: Number.isInteger(price) ? 0 : 2,
            }).format(price);
        } catch (error) {
            if (error instanceof RangeError) {
                return new Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency,
                }).format(price);
            }
        }
    }, [locale, price, currency]);

    return <>{formattedPrice}</>;
};
